// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chip-style[data-v-071709b9]{border-radius:7px}.chip-group[data-v-071709b9]{display:flex;gap:.2rem}.unselected[data-v-071709b9]{font-weight:700;background-color:var(--color-surface)}.selected[data-v-071709b9]{background-color:var(--color-text);color:var(--color-background)}.btn-common[data-v-071709b9]{background-color:var(--color-surface)}.divider-vertical[data-v-071709b9]{width:1px;height:100;background-color:var(--color-border)}", ""]);
// Exports
module.exports = exports;
